<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modalheader">
                        <h3>
                            <div class="m-4 text-center">
                                {{fetchingMessage}}
                            </div>
                        </h3>
                    </div>

                    <div class="modalbody">
                        <div class="m-2 text-center">
                            <I style="font-size: 80px;" class="rotate" name="sync"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    /* tslint:disable */
    import user from '@/store/modules/user';
    export default {
        name: 'GlobalSpinner',
        computed: {
            fetchingMessage() {
                return user.fetchingMessage;
            },
        }
    };
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 1024px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .modalheader {
        margin: 0;
    }

    .modalbody {
        margin: 20px 0;
        padding: 10px;
    }

    .modalfooter {
        margin: 20px 0;
        padding: 10px;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
